import { pushEvent } from '../../client/data-layer';
import { CategoryTreeItem } from './sub-category-map';

const atLeast = (count: number) => (item: CategoryTreeItem[]) =>
  item && Array.isArray(item) && item.length >= count;

export const atLeastOne = atLeast(1);

export const haveChildren = (item: CategoryTreeItem) =>
  atLeastOne(item.children);

export const MAIN_LINK = 'main';
export const SUBCATEGORY_LINK = 'subcategory';
export const SHOW_ALL_LINK = 'showAll';

type CategoryLinkType = 'main' | 'subcategory' | 'showAll';

export const trackClick = (
  category: CategoryTreeItem,
  linkKind: CategoryLinkType
) => {
  pushEvent('categoryListClick', {
    category,
    linkKind,
    isSubcategory: linkKind === SUBCATEGORY_LINK,
    insideHoverMenu: linkKind !== MAIN_LINK,
  });
};
